module.exports = "<div class=\"loans-catalog-detail-header\"\n     ng-class=\"{'mobile': $ctrl.isMobileApp}\">\n\n  <img ng-src=\"{{$ctrl.loan.header}}\">\n\n  <div class=\"detail-header-title\">\n    <h1>{{ $ctrl.loan.detail.title | translate }}</h1>\n\n    <button ng-hide=\"$ctrl.hideSignup\"\n            ng-click=\"$ctrl.onNavigate()\"\n            class=\"btn btn-app btn-default btn-signup\">\n      {{ 'LOANS.LOANS_DETAIL.SIGN_UP' | translate }}\n    </button>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansDetail/loansDetailHeader/loansDetailHeader.html
// module id = 1827
// module chunks = 0